// By default Swiper exports only core version without additional modules
// (like Navigation, Pagination, etc.). So you need to import and configure them too:
import Swiper, {Navigation} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default class AdfCaroussel {
    constructor(blockContainer) {

        this.blockContainer = blockContainer;
        this.slidesContainer = this.blockContainer.querySelector('.swiper-wrapper');
        this.slides = this.slidesContainer.querySelector('.swiper-slide');

        if ( this.slides && this.slides.length < 1) {
            return;
        }


        this.setupSlider();
    }

    setupSlider() {

        const swiperOptions = {
            modules: [Navigation],
            slidesPerView: 4,
            spaceBetween: 0,

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            breakpoints: {
                1: {
                    slidesPerView: 1,

                },
                768: {
                    slidesPerView: 2,

                },
                992: {
                    slidesPerView: 4,
                }
            }
        };

        this.swiperInstance = new Swiper(this.blockContainer, swiperOptions);
    }
}
